import React from "react";
import { render } from "react-dom";
// import BookCard from "../widgets/bookcard";
import NewBookCard from "../widgets/bookcard/NewBookCard";
import axios from "axios";

// Book card
let bookCardElem = document.querySelectorAll(".widget-bookcard");

if (bookCardElem.length) {
    bookCardElem.forEach(elem => {
        render(<NewBookCard elem={elem} />, elem);
    });
}
